import TouchSpinContainer from "../../../../components/formsAndTable/forms/formWidgets/touchSpin";

const TouchSpin = () => {
  return <TouchSpinContainer />;
};

export default TouchSpin;
